/**
 * Update url query parameters
 *
 * @param {string} url
 * @param {object} params
 * @return {string}
 */
const updateQueryParams = (url, params = {}) => {
    let myUrl = url;

    for (const param in params) {
        if ({}.hasOwnProperty.call(params, param)) {
            const r = new RegExp(`${param}=(.*?)(&|$)`, 'i');
            const s = myUrl.includes('?') ? '&' : '?';

            if (url.match(r)) {
                myUrl = url.replace(r, `${encodeURIComponent(param)}=${encodeURIComponent(params[param])}$2`);
            } else {
                myUrl += `${s}${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`;
            }
        }
    }

    return myUrl;
};

export default updateQueryParams;
